import { isNavigateEvent } from '../helpers';
import { AppStructureBuilderError } from './error';
export function addView(viewName) {
    this.updateAppStructure(draftBuilder => {
        if (!this.getView(viewName)) {
            draftBuilder.application.views[viewName] = { name: viewName, scopes: {} };
        }
    });
    return this;
}
export function removeView(viewName) {
    this.updateAppStructure(draftBuilder => {
        if (!draftBuilder.application.views[viewName]) {
            throw new AppStructureBuilderError(`View ${viewName} not found. Cannot remove view that does not exist.`);
        }
        draftBuilder.application.navigation = draftBuilder.application.navigation.filter(it => it.viewName !== viewName);
        delete draftBuilder.application.views[viewName];
    });
    return this;
}
export function renameView(viewName, newViewName) {
    this.updateAppStructure(draftBuilder => {
        const view = { ...draftBuilder.application.views[viewName] };
        if (!view) {
            throw new AppStructureBuilderError(`View ${viewName} not found`);
        }
        if (draftBuilder.application.views[newViewName]) {
            throw new AppStructureBuilderError(`View ${newViewName} already exists`);
        }
        delete draftBuilder.application.views[viewName];
        draftBuilder.application.views[newViewName] = { ...view, name: newViewName };
    });
    this.replaceNavigationTarget(viewName, newViewName);
    for (const event of this.getEventsByTargetViewName(viewName)) {
        this.replaceEventTarget({ eventName: event.name, newTargetViewName: newViewName });
    }
    return this;
}
export function replaceNavigationTarget(viewName, newViewName) {
    this.updateAppStructure(draftBuilder => {
        const navigation = draftBuilder.application.navigation;
        const changeNavigationTarget = (items) => {
            for (const item of items) {
                if (item.viewName === viewName) {
                    item.viewName = newViewName;
                }
                if (item.children) {
                    changeNavigationTarget(item.children);
                }
            }
        };
        changeNavigationTarget(navigation);
    });
    return this;
}
export function replaceEventTarget({ eventName, newTargetViewName }) {
    this.updateAppStructure(draftBuilder => {
        const views = Object.values(draftBuilder.application.views);
        for (const view of views) {
            if (!view.events)
                continue;
            const event = view.events[eventName];
            if (isNavigateEvent(event)) {
                event.targetViewName = newTargetViewName;
            }
        }
    });
    return this;
}
//# sourceMappingURL=viewManagement.js.map